const axios = require('axios');

class FilesClient {
    constructor(apiBasePath, staticDownloadPath) {
        this.apiBasePath = apiBasePath;
        this.staticDownloadPath = staticDownloadPath;
    }

    async request({
        path,
        method = 'get',
        body,
        query,
        // headers = {},
        token,
    } = {}) {
        const headers = {};
        if (token) {
            headers.Authorization = `Bearer ${token}`;
        }
        const response = await axios({
            url: this.apiBasePath + path,
            method,
            params: query,
            data: body,
            headers,
        });
        return response.data;
    }

    async uploadStatic(files, token) {
        const formData = new FormData();
        // formData.append('files', files);
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i]);
        }
        const body = await this.request({
            path: '/upload/static',
            method: 'post',
            body: formData,
            // headers: { "Content-Type": "multipart/form-data" },
            token,
        });
        return body.result;
    }
}

module.exports = FilesClient;
